import React from "react";
import { cn } from "../../lib/utils";

const Badge = React.forwardRef(({ className, variant = "gold", children, ...props }, ref) => {
  const variants = {
    gold: "bg-purple-900/80 border-purple-500 text-gold-100",
    ruby: "bg-purple-900/80 border-purple-500 text-ruby",
    arcane: "bg-purple-900/80 border-purple-500 text-purple-100"
  };
  
  return (
    <div
      ref={ref}
      className={cn(
        "inline-flex items-center rounded-full border px-3 py-1 text-xs font-heading tracking-wide",
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

Badge.displayName = "Badge";

export default Badge;
